import { render } from "./BookingsTable.vue?vue&type=template&id=2b25796f&scoped=true"
import script from "./BookingsTable.vue?vue&type=script&lang=js"
export * from "./BookingsTable.vue?vue&type=script&lang=js"

import "./BookingsTable.vue?vue&type=style&index=0&id=2b25796f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b25796f"]])

export default __exports__